import { render } from "./kick.vue?vue&type=template&id=7faf3aa9&ts=true"
import script from "./kick.vue?vue&type=script&lang=ts"
export * from "./kick.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__